exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".-complex-table{position:relative}.-complex-table table{background:#fff}.-table-body,.-table-footer,.-table-header{position:relative;overflow:scroll}.-fixed-table{position:absolute;top:0}.-fixed-table table{width:auto}.-left-fixed,.-right-fixed{box-shadow:1px 0 5px #ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-69ad6dfa!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue2-datatable-component/src/Table/index.vue
// module id = 905
// module chunks = 2